const googleMapInit = () => {
    const maps = Array.from(document.querySelectorAll('.bn-google-map-points'));

    function initMap(el) {
        const styles = [
            {
                "featureType": "administrative",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "-100"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 65
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": "50"
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "-100"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": "30"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": "40"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#ffff00"
                    },
                    {
                        "lightness": -25
                    },
                    {
                        "saturation": -97
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "lightness": -25
                    },
                    {
                        "saturation": -100
                    }
                ]
            }
        ];

        const markers = el.querySelectorAll('.marker');

        const mapArgs = {
            zoom: parseInt(el?.dataset.zoom || 16),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: styles,
            disableDefaultUI: true,
        };
        const map = new google.maps.Map(el, mapArgs);

        map.markers = [];
        markers.forEach(function (marker) {
            initMarker(marker, map);
        });

        centerMap(map);

        return map;
    }

    /**
     * initMarker
     *
     * Creates a marker for the given element and map.
     *
     * @param   HTMLElement marker The marker element.
     * @param   object map The map instance.
     * @return  object The marker instance.
     */
    function initMarker(marker, map) {
        // Get position from marker.
        const lat = parseFloat(marker.dataset.lat.replace(',', '.'));
        const lng = parseFloat(marker.dataset.lng.replace(',', '.'));

        const latLng = { lat: lat, lng: lng };

        const markerSetting = {
            position: latLng,
            map: map,
        };

        if (marker.dataset.icon) {
            // Pobierz rozmiar z kontenera mapy
            const mapElement = marker.closest('.bn-google-map-points');
            const iconWidth = parseInt(mapElement?.dataset.markerWidth || 128);
            const iconHeight = parseInt(mapElement?.dataset.markerHeight || 39);

            markerSetting.icon = {
                url: marker.dataset.icon,
                scaledSize: new google.maps.Size(iconWidth, iconHeight),
                anchor: new google.maps.Point(iconWidth / 2, iconHeight)
            };
        }

        const googleMarker = new google.maps.Marker(markerSetting);

        map.markers.push(googleMarker);

        // If marker contains HTML, add it to an infoWindow.
        if (marker.innerHTML.trim()) {
            // Create info window.
            const infowindow = new google.maps.InfoWindow({
                content: marker.innerHTML,
            });

            // Show info window when marker is clicked.
            googleMarker.addListener('click', function () {
                infowindow.open(map, googleMarker);
            });
        }
    }

    /**
     * Centers the map showing all markers in view.
     *
     * @param   object map The map instance.
     * @return  void
     */
    function centerMap(map) {
        const bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function (marker) {
            bounds.extend({
                lat: marker.position.lat(),
                lng: marker.position.lng(),
            });
        });

        if (map.markers.length === 1) {
            map.setCenter(bounds.getCenter());
        } else {
            map.fitBounds(bounds);
        }
    }

    if (maps) {
        maps.forEach(map => {
            initMap(map);
        });
    }
}

document.addEventListener("DOMContentLoaded", function () {
    if (!document.body.classList.contains('block-editor-page') && !document.body.classList.contains('block-editor-iframe__body'))
        googleMapInit();
});

